<span class="subtitle-50 fw-bold">{{ mobileStepperLabel$ | async }} {{ title }}</span>
